import { combineReducers } from 'redux';

import progressReducer from './progressReducer';
import currentPromptReducer from './currentPromptReducer';
import selectedFiltersReducer from './selectedFilters/selectedFiltersReducer';
import filteredResultsReducer from './filteredResultsReducer';
import promptQueueReducer from './promptQueueReducer';
import randomSeedReducer from './randomSeedReducer';
import pollVoteRegistrationReducer from './pollVoteRegistrationReducer';
import elementsViewedReducer from './elementsViewedReducer';

export default combineReducers({
    progress: progressReducer,
    currentPrompt: currentPromptReducer,
    selectedFilters: selectedFiltersReducer,
    filteredResults: filteredResultsReducer,
    promptQueue: promptQueueReducer,
    randomSeed: randomSeedReducer,
    pollVoteRegistration: pollVoteRegistrationReducer,
    elementsViewed: elementsViewedReducer
});
